/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../css/ErrorPage.module.css';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useLocation } from 'react-router-dom';

const ErrorPage = () => {
  const location = useLocation();
  const message =
    location.state?.errorPageMessage ||
    'An unexpected error occurred. Please close the application and try again or contact support.';
  return (
    <section className={Styles.page}>
      <section className={Styles.errorContainer}>
        <h1 className={Styles.errorHeader}>Something went wrong.</h1>
        <p className={Styles.errorText}>{message}</p>
        <ErrorOutlineIcon className={Styles.errorIcon} />
      </section>
    </section>
  );
};

export default ErrorPage;
